import arrayToObjArray from 'evenlea-utils/array/arrayToObjArray';

const enum0 = ['已上架', '已下架'];
let enum0Map = {
  已上架: '已上架',
  已下架: '已下架',
};
const enum1 = ['先生', '女士'];

// 商品状态
const enum2 = ['待付款', '准备中', '已发货', '已收货', '售后中', '已退款', '已取消'];

let enum2Map = {
  待付款: 'Active',
  准备中: 'Active',
  已发货: 'Active',
  已收货: 'Active',
  售后中: 'AfterSale',
  已退款: 'Refunded',
  已取消: 'Canceled',
};

// 订单状态
const enum7 = ['全部', '已支付', '制作中', '运输中', '已收货', '已完成', '售后中', '已取消'];
let enum7Map = {
  全部: undefined,
  已支付: 'Paid',
  制作中: 'InProduction',
  运输中: 'InTransit',
  已收货: 'Delivered',
  已完成: 'Completed',
  售后中: 'AfterSale',
  已取消: 'Canceled',
};

const enum3 = ['天', '周', '年'];

const enum4 = [
  '支持二级分类配置',
  '特殊分类自动包含全部产品',
  '特殊分类不需要额外配置',
  '不支持二级分类配置',
  '服务文案配置',
  '图片拼接配置',
];
let enumMap4 = {
  支持二级分类配置: '支持二级分类配置',
  特殊分类自动包含全部产品: '特殊分类自动包含全部产品',
  特殊分类不需要额外配置: '特殊分类不需要额外配置',
  不支持二级分类配置: '不支持二级分类配置',
  服务文案配置: '服务文案配置',
  图片拼接配置: '图片拼接配置',
};

const enum5 = ['系列样式', '故事样式', '没样式'];

const enum6 = ['主页大图', '小橱窗'];
let enum6Map = {
  主页大图: '主页大图',
  小橱窗: '小橱窗',
};

const enum8 = ['正常', '预售', '已售罄'];
let enum8Map = {
  正常: '正常',
  预售: '预售',
  已售罄: '已售罄',
};

// 试戴订单状态
const enum9 = ['准备中', '已发货', '已取消', '已完成'];
let enum9Map = {
  准备中: '准备中',
  已发货: '已发货',
  已取消: '已取消',
  已完成: '已完成',
};

// 试戴订单的退回状态，后端有一个【待申请】不过实际上不存在这个状态的
const enum10 = ['待退回', '待上门', '运输中', '镜架已退回', '押金已退回', '状态异常'];
let enum10Map = {
  待退回: '待退回',
  待上门: '待上门',
  运输中: '运输中',
  镜架已退回: '镜架已退回',
  押金已退回: '押金已退回',
  状态异常: '状态异常',
};

let appConfig = {
  httpType: 'https',
  host: 'softbuilder.cn',
  port: '',

  elementUiSize: 'small',

  wangeditorConfigDefault: {
    toolbarConfig: {
      excludeKeys: ['insertVideo', 'insertTable', 'fullScreen', 'codeBlock', 'todo', 'redo', 'undo'],
    },
  },

  enum0,
  enum0Map,
  selectOptions0: arrayToObjArray(enum0),

  enum1,
  selectOptions1: arrayToObjArray(enum1),

  enum2,
  enum2Map,
  selectOptions2: arrayToObjArray(enum2),

  enum3,
  selectOptions3: arrayToObjArray(enum3),

  enum4,
  enumMap4,
  selectOptions4: arrayToObjArray(enum4),

  enum5,
  selectOptions5: [
    {
      // label: 'WALDEN ORIGIN系列',
      label: '系列样式',
      value: '系列样式',
    },
    // {
    //   label: '故事样式',
    //   value: '故事样式',
    // },
  ],

  enum6,
  enum6Map,
  selectOptions6: arrayToObjArray(enum6),

  enum7,
  enum7Map,
  selectOptions7: arrayToObjArray(enum7),

  enum8,
  enum8Map,
  selectOptions8: arrayToObjArray(enum8),

  enum9,
  enum9Map,
  selectOptions9: arrayToObjArray(enum9),

  enum10,
  enum10Map,
  selectOptions10: arrayToObjArray(enum10),
};

if (process.env.VUE_APP_ENV === 'development') {
  appConfig.httpType = `http`;
  appConfig.host = `127.0.0.1`;
  appConfig.port = `5267`;
}

if (process.env.VUE_APP_ENV === 'production') {
  appConfig.httpType = `https`;
  appConfig.host = `waldenoptical.cn`;
  appConfig.port = ``;
}

// if (process.env.VUE_APP_ENV === 'staging') {
// }

export default appConfig;
